<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content position-relative" id="pdfDom" :class="loadingPdf ? 'pdf-width' : ''">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                <em-workflow-business-data-editor ref="businessDataEditor"
                                                  :entity="modelName"
                                                  :allow-edit="false"
                                                  $_em-custom-vuex-mixin_configs="sithMesNcrProcessTaskProcessVoConfigs"
                                                  query-api="typeProcess"
                                                  :business-data="$_emWorkflowTaskMixin_businessData">
                    <template #titleAppend>
                        <b-button v-if="showPoSelectButton"
                                  class="ml-2 align-middle"
                                  variant="outline-primary"
                                  size="sm"
                                  @click="openPoSelectModal">
                            <i class="fa fa-fw fa-link"></i>
                            选择PO信息
                        </b-button>
                    </template>
                </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      sync-value-change
                                      :config="config">
                </WorkflowTaskComplete>
            </div>

            <em-button type="downloadFile" @click="savePdf"
                       class="btn btn-outline-primary btn-sm position-absolute top right mt-1 mr-1"
                       style="z-index: 900"
                       v-if="!loadingPdf"></em-button>
        </section>
        <re-b-modal ref="poSelectModal" header="选择PO信息" large no-auto-hide
                    :ok-loading="poSaving" ok-label="确 定" @ok="confirmPoSelect">
            <div v-if="poLoading" class="text-center my-3">
                <b-spinner small></b-spinner>
                加载中...
            </div>
            <template v-else>
                <b-table ref="poTable"
                         :items="poList"
                         :fields="poFields"
                         selectable
                         select-mode="single"
                         selected-variant="primary"
                         @row-selected="onPoRowSelected"
                         sticky-header="400px"
                         small
                         bordered
                         hover>
                    <template #head(selected)>
                        <div class="text-center"><input type="radio" disabled></div>
                    </template>
                    <template #cell(selected)="{ rowSelected, index }">
                        <div class="text-center" style="cursor: pointer">
                            <input type="radio" :checked="rowSelected" @click.stop="onRadioSelect(index)">
                        </div>
                    </template>
                </b-table>
                <div v-if="poList.length === 0" class="text-center text-muted my-3">
                    该工单号在全部PO订单中未关联到PO信息
                </div>
            </template>
        </re-b-modal>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2021-04-26 11:06:52

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import {_causedByOptions} from "@/views/sithMes/quality/NCR/stuff/causedByOption";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesNcrProcessTaskWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete, ReBModal},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins, emCommonApiMixin],
    data() {
        return {
            htmlTitle: '导出PDF',
            loadingPdf: false,
            poLoading: false,
            poSaving: false,
            poList: [],
            selectedPoRows: [],
            poFields: [
                {key: 'selected', label: '选择', thStyle: {width: '48px'}, tdClass: 'text-center'},
                {key: 'purchasingDocNumber', label: '采购订单号'},
                {key: 'purchasingDocItemNumber', label: '采购订单行'},
                {key: 'vendorNameZh', label: '供应商名称'},
                {key: 'vendorAccountNumber', label: '供应商编码'},
                {key: 'creatorName', label: '采购员'},
                {key: 'materialNumber', label: '物料号'},
                {key: 'materialShortText', label: '物料描述'}
            ],
            currentUserIsAdmin: false
        }
    },
    mounted() {
        //查询状态下仅系统管理员可关联PO，进入页面时先判定当前用户是否管理员
        this.$_emApiMixin_get(process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/currentUser").then(user => {
            //isAdministrator由后端鉴权链路给出；SSO关闭等场景可能为空，退回loginName==='admin'
            this.currentUserIsAdmin = (user && user.isAdministrator === true) || (user && user.loginName === 'admin');
        });
    },
    methods: {
        savePdf() {
            this.loadingPdf = true;
            setTimeout(() => this.getPdf('#pdfDom'), 2000);
            setTimeout(() => this.loadingPdf = false, 5000);
        },
        openPoSelectModal() {
            //orderCode(工单编号)只在typeProcess查询结果(编辑器的businessDataFromApi)中存在
            let fromApi = this.$refs.businessDataEditor ? this.$refs.businessDataEditor.businessDataFromApi : null;
            let orderCode = (fromApi && fromApi.orderCode) || this.$_emWorkflowTaskMixin_businessData.orderCode;
            if (!this.hasCode(orderCode)) {
                this.$message.warning("该NCR未关联工单编号，无法查询PO信息");
                return;
            }
            this.selectedPoRows = [];
            this.poList = [];
            this.poLoading = true;
            this.$refs.poSelectModal.showModal();
            let api = process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/findPoByWorkOrder"
                + "?orderCode=" + orderCode;
            this.$_emApiMixin_get(api).then(response => {
                //api/get已解包response.data，response即PO数组
                this.poList = response || [];
                if (this.poList.length === 0) {
                    this.$message.warning("该工单号在全部PO订单中未关联到PO信息");
                }
            }).finally(() => this.poLoading = false);
        },
        onPoRowSelected(rows) {
            this.selectedPoRows = rows;
        },
        onRadioSelect(index) {
            //点单选按钮与点击行效果一致：单选高亮并选中该行
            this.$refs.poTable.selectRow(index);
        },
        confirmPoSelect() {
            if (this.selectedPoRows.length === 0) {
                this.$message.warning("请先选择一条PO信息");
                return;
            }
            let po = this.selectedPoRows[0];
            this.poSaving = true;
            let api = process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/selective";
            this.$_emApiMixin_put(api, {
                id: this.$_emWorkflowTaskMixin_businessKey,
                poNumber: po.purchasingDocNumber,
                poItem: po.purchasingDocItemNumber,
                supplier: po.vendorNameZh,
                supplierNum: po.vendorAccountNumber,
                purchaser: po.creatorName
            }).then(() => {
                this.$message.success("PO信息已关联");
                let businessData = JSON.parse(JSON.stringify(this.$_emWorkflowTaskMixin_businessData));
                businessData.poNumber = po.purchasingDocNumber;
                businessData.poItem = po.purchasingDocItemNumber;
                businessData.supplier = po.vendorNameZh;
                businessData.supplierNum = po.vendorAccountNumber;
                businessData.purchaser = po.creatorName;
                this.$_setBusinessData(businessData);
                //主数据展示来自typeProcess查询(businessDataFromApi)，重新拉取以刷新显示
                this.$refs.businessDataEditor.getBusinessDataByQueryApi();
                this.$refs.poSelectModal.hide();
            }).finally(() => this.poSaving = false);
        }
    },
    computed: {
        isTodoStatus() {
            //从待办进入路由带pathType=todo；其余(list/claim/缺省)均视为查询查看状态
            return this.$_emWorkflowTaskMixin_pathType === "todo";
        },
        /**
         * "选择PO信息"按钮可见性规则：
         *  1) 无业务数据(id)时一律隐藏（数据未就绪，无法回填PO）。
         *  2) 待办(todo)：按钮可见。即 NCR 流程链路上的持票人（发起人 / 被流转指派为
         *     下一处理人的用户）从待办进入时，均可点选补充 PO 信息，不受管理员限制。
         *  3) 查询/查看状态(list / claim / 缺省)：按钮仅对系统管理员可见，
         *     普通用户不可见。currentUserIsAdmin 由 mounted 中拉取的
         *     /emAclUser/currentUser 判定（isAdministrator === true 或 loginName === 'admin'）。
         * 综上：可见 = 有业务id 且 (待办状态 || 系统管理员)；其余场景不可见。
         */
        showPoSelectButton() {
            if (!this.hasCode(this.$_emWorkflowTaskMixin_businessData.id)) {
                return false;
            }
            //待办：NCR流程链路上的用户均可补充PO信息；查询查看：仅系统管理员可操作
            return this.isTodoStatus || this.currentUserIsAdmin;
        },
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/complete-feedback";
        },
        config() {
            return {
                'task_ncr_init': {
                    name: 'NCR信息完善',
                    variables: [
                        {
                            label: '责任确认',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '供应商责任'},
                                {value: 2, text: 'SITH责任'},
                                {value: 3, text: '内部流转'},
                                {value: 4, text: '实际关闭'},
                                {value: 5, text: '可记录NCR'},
                                {value: 6, text: '体外NCR信息详情'},
                            ]
                        },
                        {
                            label: 'NCR描述',
                            name: 'ncrDescription',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            label: 'NCR Comments',
                            name: 'NCR_Comments',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                            require: true
                        },
                        {
                            label: 'Causes by',
                            name: 'causedBy',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: _causedByOptions(),
                            initData: true,
                            require: true
                        },
                        {
                            label: 'NCR风险等级',
                            name: 'ncr_risk_level',
                            type: this.VALUE_TYPE.SELECT,
                            options: [
                                {value: 1, text: '低'},
                                {value: 2, text: '高'}
                            ],
                            require: true
                        },
                        {
                            label: '数量',
                            name: 'ncr_count',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                            require: true
                        }
                    ],
                    withAttachment: true,
                    addVariableByApprove: approve => {
                        let temp = {
                            4: 'C0', 5: 'C3'
                        }
                        if (approve === 4 || approve === 5) {
                            return {name: 'solutionCode', value: temp[approve]};
                        }
                    },
                    copyToData: true,
                    userSelectMap: {
                        '*': [
                            {
                                name: 'task_candidateUsers',
                                allowMulti: true,
                                require: true
                            },
                            {
                                name: 'email_cc',
                                labelWithout: 'Email Cc',
                                allowMulti: true
                            }
                        ],
                        2: [
                            {
                                name: 'task_tc_examine_candidateUsers',
                                allowMulti: true,
                                require: true
                            },
                            {
                                name: 'email_cc',
                                labelWithout: 'Email Cc',
                                allowMulti: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task_purchase_examine',
                        2: 'task_tc_examine',
                        3: 'task_ncr_init',
                        4: 'task_actual_off',
                        5: 'task_tc_solution',
                        6: 'task_ncr_detail_input'
                    }
                },
                'task_ncr_detail_input': {
                    name: '体外NCR信息详情',
                    variables: [
                        {
                            label: '工程号',
                            name: 'projectCode',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        },
                        {
                            repeat: true,
                            labelWithName: {
                                'nameOfParts': '零部件名称',
                                'pictureNo': '图号',
                                'materialNo': '物料号',
                                'bgCidNo': 'BG/CID号',
                                'material': '材料',
                                'operationNo': '工序序号',
                                'productionType': '产品种类',
                                'equipmentCode': '设备编号',
                                'designer': '设计者',
                                'craftsman': '工艺员',
                                'operator': '操作者',
                                'purchaseNo': '采购单号',
                                'purchaseItemNo': '采购Item No',
                                'purchaser': '采购员',
                                'reason': '原因',
                            },
                            type: this.VALUE_TYPE.INPUT,
                        },
                        {
                            label: '供方',
                            name: 'supplier',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        },
                        {
                            label: '重复性',
                            name: 'happenType',
                            type: this.VALUE_TYPE.SELECT,
                            options: ['第一次发生', '重复性发生']
                        }
                    ],
                    withAttachment: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_tc_examine_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: 'task_tc_examine'
                },
                'task_purchase_examine': {
                    name: '采购批复',
                    variables: [
                        {
                            label: '反馈意见',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '申请让步接受'},
                                {value: 2, text: 'SITH修复'},
                                {value: 3, text: '供应商换货或供应商自行修复'},
                                {value: 4, text: '供应商退货'},
                                {value: 5, text: '信息补充'},
                            ]
                        }
                    ],
                    withAttachment: true,
                    addVariableByApprove: approve => {
                        let tempMap = {
                            1: 'A1',
                            2: 'A2',
                            3: 'A3',
                            4: 'A4',
                            5: 'C4',
                        }
                        return {name: 'solutionCode', value: tempMap[approve]};
                    },
                    copyToData: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [{
                            name: 'task_tc_examine_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_tc_confirm_compromise',
                        2: 'task_tc_confirm_repair',
                        '3,4': 'task_technical_off',
                        5: 'task_ncr_init'
                    }
                },
                'task_tc_confirm_compromise': {
                    name: '技术批复是否可让步',
                    approveLabel: '是否可让步',
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: {
                        1: 'task_technical_off',
                        2: 'task_purchase_examine'
                    }
                },
                'task_tc_confirm_repair': {
                    tag: {},
                    name: '技术判断是否可修复',
                    variables: [
                        {
                            label: '是否可修复',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '可修复'},
                                {value: 2, text: '不可修复，转-供应商换货或供应商自行修复'}
                            ],
                            changeTag: val => {
                                return this.buildTag('repair', val === 1);
                            }
                        },
                        {
                            needTag: 'repair',
                            label: 'Group No.',
                            name: 'group_num',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        },
                        {
                            needTag: 'repair',
                            label: 'Material No.',
                            name: 'material_num',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            needTag: 'repair',
                            label: 'Material Quantity',
                            name: 'material_qua',
                            type: this.VALUE_TYPE.INPUT
                        },
                        {
                            needTag: 'repair',
                            label: '工程师意见',
                            name: 'TC_Comment',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        }
                    ],
                    withAttachment: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    addVariableByApprove: approve => {
                        if (approve === 2) {
                            return {name: 'solutionCode', value: 'A3'};
                        }else if (approve === 1) {
                            return {name: 'solutionCode', value: 'A2'};
                        }
                    },
                    copyToData: true,
                    approveToNextTask: {
                        1: 'task_tc_solution',
                        2: 'task_technical_off'
                    }
                },
                'task_tc_examine': {
                    name: '技术批复及编写工艺',
                    tag: {},
                    variables: [
                        {
                            label: 'NCR 处理方式',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '让步接受'},
                                {value: 2, text: 'SITH修复'},
                                {value: 3, text: '报废-SITH自制'},
                                {value: 4, text: '报废-采购成品'},
                                {value: 5, text: '信息补充'},
                                // {value: 6, text: '实际关闭'},
                            ],
                            changeTag: val => {
                                return this.buildTag('repair', val === 2 || val === 3 || val === 4);
                            }
                        },
                        {
                            needTag: 'repair',
                            label: 'Group No.',
                            name: 'group_num',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        },
                        {
                            needTag: 'repair',
                            label: 'Material No.',
                            name: 'material_num',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            needTag: 'repair',
                            label: 'Material Quantity',
                            name: 'material_qua',
                            type: this.VALUE_TYPE.INPUT
                        },
                        {
                            label: '工程师意见',
                            name: 'TC_Comment',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        }
                    ],
                    withAttachment: true,
                    addVariableByApprove: approve => {
                        let tempMap = {
                            1: 'B1',
                            2: 'B2',
                            3: 'B3',
                            4: 'B4',
                            5: 'C1',
                            6: 'C2'
                        }
                        return {name: 'solutionCode', value: tempMap[approve]};
                    },
                    copyToData: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: {
                        '1,6': 'task_technical_off',
                        '2,3,4': 'task_tc_solution',
                        5: 'task_ncr_init',
                    }
                },
                'task_tc_solution': {
                    name: '判断是否需要特殊工艺',
                    tag: {},
                    variables: [
                        {
                            label: '特殊工艺',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '需要'},
                                {value: 2, text: '不需要'}
                            ],
                            changeTag: val => {
                                return this.buildTag('specialSolution', val === 1);
                            }
                        },
                        {
                            needTag: 'specialSolution',
                            label: '热处理',
                            name: 'solution_hot',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW,
                        },
                        {
                            needTag: 'specialSolution',
                            label: '焊接',
                            name: 'solution_welding',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW,
                        },
                        {
                            needTag: 'specialSolution',
                            label: 'CNC编程',
                            name: 'solution_cnc',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW,
                        },
                        {
                            needTag: 'mark',
                            label: 'Group No.',
                            name: 'group_num',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        },
                        {
                            needTag: 'mark',
                            label: 'Material No.',
                            name: 'material_num',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            needTag: 'mark',
                            label: 'Material Quantity',
                            name: 'material_qua',
                            type: this.VALUE_TYPE.INPUT
                        },
                        {
                            label: '工程师意见',
                            name: 'tc_comment',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW
                        }
                    ],
                    changeTag: (businessData) => {
                        return this.buildTag('mark', businessData.solutionCode === 'C3');
                    },
                    withAttachment: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [
                            {
                                name: 'task_candidateUsers',
                                label: '内部审核',
                                allowMulti: true,
                                require: true
                            },
                            {
                                name: 'task_next_candidateUsers',
                                label: 'PP',
                                allowMulti: true,
                                require: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task_special_solution',
                        2: 'task_tc_confirm_solution'
                    }
                },
                'task_special_solution': {
                    name: '特殊工艺',
                    withAttachmentNotNull: true,
                    approveToNextTask: 'task_tc_solution'
                },
                'task_tc_confirm_solution': {
                    name: '内部审核',
                    approveLabel: '是否通过',
                    setApproveBeforeSubmit: approve => {
                        if (approve === 2) {
                            if (this.taskLocalVariables.solutionCode && this.taskLocalVariables.solutionCode === 'A2') {
                                return 3;
                            }
                        }
                        return approve;
                    },
                    withComment: true,
                    approveToNextTask: {
                        1: 'task_pp_order_code',
                        2: 'task_tc_examine',
                        3: 'task_tc_confirm_repair'
                    }
                },
                'task_pp_order_code': {
                    name: 'PP：生成生产订单号',
                    variables: [
                        {
                            label: '生产订单号',
                            name: 'ppHeaderId',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        }
                    ],
                    withComment: true,
                    withAttachment: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: 'task_technical_off'
                },
                'task_technical_off': {
                    name: 'NCR技术关闭',
                    variables: [
                        {
                            label: 'NCR技术关闭',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 10, text: '技术关闭'},
                                {
                                    label: '回溯', options: [
                                        {value: 3, text: 'NCR信息完善'},
                                        {value: 6, text: '采购批复'},
                                        {value: 5, text: '技术判断是否让步'},
                                        {value: 4, text: '技术判断是否修复'},
                                        {value: 2, text: '技术批复及编写工艺'},
                                        {value: 7, text: '工程师编写工艺'},
                                        {value: 1, text: 'PP生成生产订单号'},
                                    ]
                                }
                            ]
                        },
                    ],
                    withComment: true,
                    setApproveBeforeSubmit: approve => {
                        if (approve === 10) {
                            if (this.taskLocalVariables.hasOwnProperty('solutionCode')) {
                                let solutionCode = this.taskLocalVariables.solutionCode;
                                switch (solutionCode) {
                                    case 'A1':
                                    case 'A3':
                                    case 'A4':
                                    case 'B1':
                                    case 'C2':
                                        return 11;
                                    case 'A2':
                                    case 'B2':
                                    case 'B3':
                                    case 'B4':
                                    case 'C3':
                                        return 12;
                                    default:
                                        return 13;
                                }
                            }
                        }
                        return approve;
                    },
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        1: [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        '2,4': [{
                            name: 'task_tc_examine_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        13: [{
                            name: 'task_next_candidateUsers',
                            label: '财务',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    postByApprove: (approve) => {
                        let off = approve > 10;
                        return {
                            url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/technical/off",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                                technicalOff: off
                            }
                        };
                    },
                    approveToNextTask: {
                        1: 'task_pp_order_code',
                        2: 'task_tc_examine',
                        3: 'task_ncr_init',
                        4: 'task_tc_confirm_repair',
                        5: 'task_tc_confirm_compromise',
                        6: 'task_purchase_examine',
                        7: 'task_tc_solution',
                        11: 'task_actual_off',
                        12: 'task_pp_teco',
                        13: 'task_waiting_finish'
                    }
                },
                'task_pp_teco': {
                    name: 'PP：TECO',
                    approveLabel: '是否TECO',
                    userSelectMap: {
                        '*': [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_cal_ncc',
                        2: 'task_technical_off'
                    }
                },
                'task_cal_ncc': {
                    name: '财务：计算NCC',
                    variables: [
                        {
                            label: 'NCC',
                            name: 'ncc',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            label: 'NCR额外成本',
                            name: 'NCR_extra_cost',
                            type: this.VALUE_TYPE.INPUT
                        }
                    ],
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: 'task_actual_off'
                },
                'task_waiting_finish': {
                    name: '等待工单完成',
                    userSelectMap: {
                        '*': [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: 'task_cal_ncc'
                },
                'task_actual_off': {
                    name: 'NCR实际关闭',
                    variables: [
                        {
                            label: 'NCR实际关闭',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 10, text: '实际关闭'},
                                {
                                    label: '回溯', options: [
                                        {value: 2, text: '财务计算NCC'},
                                        {value: 1, text: 'NCR技术关闭'},
                                    ]
                                }
                            ]
                        },
                    ],
                    withComment: true,
                    setApproveBeforeSubmit: approve => {
                        if (approve === 10) {
                            if (this.taskLocalVariables.hasOwnProperty('solutionCode')) {
                                let solutionCode = this.taskLocalVariables.solutionCode;
                                switch (solutionCode) {
                                    case 'A1':
                                    case 'A3':
                                    case 'A4':
                                    case 'B1':
                                    case 'C0':
                                    case 'C2':
                                    case 'C3':
                                        return 11;
                                    case 'A2':
                                        return 12;
                                    case 'B2':
                                    case 'B3':
                                    case 'B4':
                                        return 14;
                                }
                            }
                        }
                        return approve;
                    },
                    setApproveByBusinessData: (businessData, approve) => {
                        if (!businessData.need8dAnalysis && approve === 14) {
                            return 15;
                        }
                        return approve;
                    },
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        '11,13,15': []
                    },
                    postByApprove: (approve) => {
                        let off = approve > 10;
                        return {
                            url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/actual/off",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                                actualOff: off
                            }
                        };
                    },
                    approveToNextTask: {
                        1: 'task_technical_off',
                        2: 'task_cal_ncc',
                        '11,13': 'task_end',
                        12: 'task_supplier_ncc',
                        14: 'task_8d_analysis'
                    }
                },
                'task_supplier_ncc': {
                    name: '向供应商索赔NCC',
                    variables: [
                        {
                            repeat: true,
                            labelWithName: {
                                'recoverNcc': '追回索赔金额',
                                'recoverNccRemark': '索赔项备注'
                            },
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        }
                    ],
                    approveToNextTask: 'task_end'
                },
                'task_8d_analysis': {
                    name: '质量：发起8D分析',
                    withAttachmentNotNull: true,
                    approveToNextTask: 'task_end'
                },
                'task_end': {
                    name: '无'
                }
            }
        }
    },
}
</script>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>